
<table mat-table matSort class="incidents" [dataSource]="dataSource">

    <ng-container matColumnDef="EventDate">
        <th mat-header-cell *matHeaderCellDef>Dato</th>
        <td mat-cell *matCellDef="let element; let i = index">
            <div class="column-wrapper">
                <span class="column-data">
                    {{element.Created | date: 'dd.MM.yyyy'}}
                </span>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="UploadedBy">
        <th mat-header-cell *matHeaderCellDef>Avsender</th>
        <td mat-cell *matCellDef="let element; let i = index">
            <div class="column-wrapper">
                <span class="column-data">
                    {{element.UploadedBy}}
                </span>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="Name">
        <th mat-header-cell *matHeaderCellDef>Navn</th>
        <td mat-cell *matCellDef="let element; let i = index">

            <div class="column-wrapper">
                <span class="column-data">

                    <span [matTooltip]="element.ComplaintDescription" *ngIf="element.Documents.length === 0">
                        {{element.Description}}
                    </span>

                    <span [matTooltip]="element.ComplaintDescription" *ngIf="element.Documents.length > 0">
                        <span class="click link" (click)="openAllByAttachmentGroup(element.Gid, currentCase.CaseUid)">
                            {{element.Description}}
                        </span>
                    </span>

                </span>
            </div>

            
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let rowData; columns: displayedColumns;"></tr>

</table>

<div class="flex-row" style="margin: 1em" *ngIf="(!currentCase?.IsComplainer || (currentCase?.IsComplainer && !currentCase?.HasCorrespondent)) && !showSendLetterComponent">
    <button style="flex:0 1 150px" (click)="toggleSendLetter()" class="finkn-btn" mat-raised-button color="primary" role="button" *ngIf="!showSendLetterComponent">
        Send brev
    </button>
</div>

<div *ngIf="showSendLetterComponent" class="flex-column flex-gap-20 letter-container">

    <p><strong>Kort beskjed - maks 500 tegn</strong></p>

    <mat-form-field class="flex-grow">
        <mat-label>Send kort beskjed til FinKN</mat-label>
        <textarea [(ngModel)]="messageBody" #description matInput rows="6" maxlength="500" placeholder="(Send kort beskjed til FinKN)"></textarea>
        <mat-hint align="end">{{description.value.length || 0}} av 500 tegn</mat-hint>
    </mat-form-field>

    <div class="dragpanel" appDnd (fileDropped)="onFileDropped($event)">
        <app-file-upload #fileUpload></app-file-upload>
    </div>

    <div class="flex-row flex-gap-20">
        <button style="flex: 0 1 150px;" (click)="submit()" [disabled]="isUploading || (files.length === 0 && messageBody === '')"
            class="finkn-btn" color="primary" mat-raised-button type="button">Send inn</button>
        <button style="flex: 0 1 150px;" [disabled]="isUploading" class="finkn-btn" color="primary" mat-raised-button
            type="button" (click)="closeSendLetterComponent()">Avbryt</button>
    </div>
</div>

